import '../../styles/style.css';

const Info = () => {
    return (
        <div className="infoContent">
            <h1 className="heading1">Welcome</h1>
            <p className="descriptionText">
                Explore around and learn more about me.
                Interact with the posters to see projects
                I've worked on. You can also look into "2D"
                Mode to more quickly learn about me!
            </p>
            <p>__________________________________________</p>

            <p className="descriptionText">
                Follow the path, beyond the <span className='voidText'>void</span>
            </p>
        </div>
    )
}

export default Info;